// extracted by mini-css-extract-plugin
module.exports = {"carousel":"CarouselBanner_carousel__CGNrh"};